import { UiSchema } from '@rjsf/core';
import { JSONSchema7 } from 'json-schema';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { IntakeForm } from 'views/pages/client-record/useIntakeForm';
import JsonFormContainer from '../JsonFormContainer';
import Actions from './Actions';

const uiSchema: UiSchema = {
  treatmentHistory_1: { 'ui:widget': 'radio', 'ui:options': { inline: true } },
  treatmentHistory_2: { 'ui:widget': 'radio', 'ui:options': { inline: true } },
  treatmentHistory_3: { 'ui:widget': 'radio', 'ui:options': { inline: true } },
  treatmentHistory_3_1: { 'ui:widget': 'textarea' }
};

interface Props {
  intakeForm: IntakeForm;
  onPrevious?: () => void;
  isSubmitting: boolean;
  onSubmit: (data: any) => void;
}

export default function TreatmentHistory({ intakeForm, onPrevious, isSubmitting, onSubmit }: Props) {
  const intl = useIntl();
  const schema: JSONSchema7 = {
    type: 'object',
    title: intl.formatMessage({ defaultMessage: 'Treatment History' }),
    properties: {
      treatmentHistory_1: {
        type: 'string',
        title: intl.formatMessage({
          defaultMessage: 'Are you currently receiving psychiatric services, professional counseling or psychotherapy elsewhere?'
        }),
        enum: [intl.formatMessage({ defaultMessage: 'Yes' }), intl.formatMessage({ defaultMessage: 'No' })]
      },
      treatmentHistory_2: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Have you had previous psychotherapy?' }),
        enum: [intl.formatMessage({ defaultMessage: 'Yes' }), intl.formatMessage({ defaultMessage: 'No' })]
      },
      treatmentHistory_2_1: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: "Previous Provider's Name" })
      },
      treatmentHistory_3: {
        type: 'string',
        title: intl.formatMessage({
          defaultMessage: 'Are you currently taking prescribed psychiatric medication (antidepressants or others)?'
        }),
        enum: [intl.formatMessage({ defaultMessage: 'Yes' }), intl.formatMessage({ defaultMessage: 'No' })]
      },
      treatmentHistory_3_1: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Please list:' })
      },
      treatmentHistory_3_2: {
        type: 'string',
        title: intl.formatMessage({ defaultMessage: 'Prescribed by:' })
      }
    }
  };
  const [formData, setFormData] = useState(intakeForm.treatmentHistory);

  return (
    <JsonFormContainer
      noValidate
      schema={schema}
      uiSchema={uiSchema}
      formData={formData}
      onChange={({ formData }) => setFormData(formData)}
      onSubmit={({ formData }) =>
        onSubmit({
          treatmentHistory: formData
        })
      }
    >
      <Actions onPrevious={onPrevious} disabled={isSubmitting} />
    </JsonFormContainer>
  );
}
